import { render } from "./TitleOption.vue?vue&type=template&id=74f54c6e&scoped=true&ts=true&lang=pug"
import script from "./TitleOption.vue?vue&type=script&lang=ts"
export * from "./TitleOption.vue?vue&type=script&lang=ts"

import "./TitleOption.vue?vue&type=style&index=0&id=74f54c6e&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f54c6e"]])

export default __exports__